import { render, staticRenderFns } from "./EleEditableDate.vue?vue&type=template&id=39f0dda4&"
import script from "./EleEditableDate.vue?vue&type=script&lang=js&"
export * from "./EleEditableDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports